(() => {
  class InteractiveProductShowcase extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;
      const panels = [...this.querySelectorAll('[data-showcase-media]')];
      const mobilePanels = [...this.querySelectorAll('[data-showcase-mobile-panel]')];
      const triggers = [...this.querySelectorAll('[data-showcase-trigger]')];
      const progressItems = [...this.querySelectorAll('[data-showcase-progress]')];
      const navigation = this.querySelector('[data-showcase-navigation]');
      const scroller = this.querySelector('[data-showcase-scroller]');
      const desktopQuery = matchMedia('(min-width: 1100px) and (min-height: 700px) and (hover: hover) and (pointer: fine)');
      let activeKey;

      const activate = (key = 'main') => {
        if (key === activeKey) return;
        activeKey = key;

        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.showcaseMedia === key));
        triggers.forEach((trigger) => trigger.classList.toggle('is-active', trigger.dataset.showcaseTrigger === key));
        progressItems.forEach((item) => item.classList.toggle('is-active', item.dataset.showcaseProgress === key));
      };

      const syncMobileState = () => {
        if (desktopQuery.matches || scroller.clientWidth === 0 || mobilePanels.length === 0) return;

        const index = Math.min(
          Math.max(Math.round(scroller.scrollLeft / scroller.clientWidth), 0),
          mobilePanels.length - 1
        );
        activate(mobilePanels[index]?.dataset.showcaseMedia);
      };

      const setupMobilePanels = () => {
        if (!desktopQuery.matches) syncMobileState();
        else activate();
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('pointerenter', () => activate(trigger.dataset.showcaseTrigger), { signal });
        trigger.addEventListener('focus', () => activate(trigger.dataset.showcaseTrigger), { signal });
      });

      navigation?.addEventListener('pointerleave', () => activate(), { signal });
      navigation?.addEventListener(
        'focusout',
        () => requestAnimationFrame(() => !navigation.contains(document.activeElement) && activate()),
        { signal }
      );
      scroller.addEventListener('scroll', syncMobileState, { passive: true, signal });
      desktopQuery.addEventListener('change', setupMobilePanels, { signal });

      this.addEventListener(
        'shopify:block:select',
        (event) => {
          const trigger = event.target.closest('[data-showcase-trigger]');
          if (!trigger) return;

          if (!desktopQuery.matches) {
            const panel = mobilePanels.find((item) => item.dataset.showcaseMedia === trigger.dataset.showcaseTrigger);
            if (panel) scroller.scrollTo({ left: panel.offsetLeft, behavior: 'smooth' });
          } else {
            activate(trigger.dataset.showcaseTrigger);
          }
        },
        { signal }
      );
      this.addEventListener('shopify:block:deselect', () => desktopQuery.matches && activate(), { signal });

      setupMobilePanels();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = undefined;
    }
  }

  if (!customElements.get('interactive-product-showcase')) {
    customElements.define('interactive-product-showcase', InteractiveProductShowcase);
  }
})();
